import type { AccountPermission } from 'store/types';

/**
 * See [here](https://skyslope.atlassian.net/wiki/spaces/DEVGEN/pages/3153690646/Defining+Every+SkySlope+User+Permission)
 * for explanations of the different permissions.
 *
 * Read below for a brief explanation of the permissions' hierarchy.
 */
export const permissionHierarchy: { [key in AccountPermission]?: AccountPermission[] } = {
  'forms.*': ['forms.template.*', 'forms.clauses.*', 'forms.libraries.*', 'forms.buyeragreement.*'],
  'forms.template.*': ['forms.template.write'],
  'forms.clauses.*': ['forms.clauses.write'],
  'forms.libraries.*': ['forms.libraries.write'],
};

/**
 * Permissions are defined in a hierarchy, where root.* will also imply
 * root.foo, root.bar, and root.child.baz.
 *
 * This function expands the hierarchy to include all implied permissions.
 */
export function expandPermission(permission: AccountPermission): AccountPermission[] {
  if (!permissionHierarchy[permission]) return [permission];
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return [permission, ...permissionHierarchy[permission]!.flatMap(expandPermission)];
}
